import CompanySettingsModule from './CompanySettings/CompanySettingsModule';
import EmployeesModule from './Employees/EmployeesModule';
import InvoicesModule from './Invoices/InvoicesModule';

export default {
  namespaced: true,
  state: {
    key: 'CompanyAdminModule',
  },
  modules: {
    CompanySettingsModule,
    EmployeesModule,
    InvoicesModule,
  },
};
